import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import JsonTableEditor from "../../atoms/jsonFormEditor/JsonTableEditor";
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js"
import UpdateCancel from '../../atoms/buttons/UpdateCancel.js';
import { Grid } from '@material-ui/core';
import { invokePostService, invokeGetService, setReRender, handleSnackBar } from '../../../store/global/actions';
import './style.css'
import { getDetailsFromUrl } from '../../../services/blueprint.js';


export default function ChildTransactionConfiguration({ onClose, simulationTransactionId, testCaseId, conditionFlag, loopFlag, testcase_name }) {

    const dispatch = useDispatch();
    const { entityId } = getDetailsFromUrl()


    const [schemaValues, setSchemaValues] = useState({});
    const [isFetching, setIsFetching] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [formData, setFormData] = useState({});
    const [editorSchema, setEditorSchema] = useState({});
    const [editorObj, setEditorObj] = useState(null);

    const fetchSimulationTransaction = () => {
        setIsFetching(true);
        
        dispatch(invokeGetService('getSimulationTransaction', [simulationTransactionId])).then((response) => {
            if (response.status) {
                findConfigurationFormSchema();
                generateFormSchemaData(response.data);
            }
            setIsFetching(false);
        });
    }

    const findConfigurationFormSchema = () => {
        const schema = {
            type: 'object',
            required: [],
            options: {
                layout: 'grid',
                disable_properties: 'false',
            },
            properties: {}
        };

        if (conditionFlag) {
            schema.properties.condition = {
                title: 'Condition',
                type: 'string',
                enumSource: [{
                    source: [{ title: 'True', value: true }, { title: 'False', value: false }],
                    title: '{{item.title}}',
                    value: '{{item.value}}'
                }],
                format: "grid",
                options: {
                    layout: 'grid',
                    grid_columns: 12,
                }
            };

        }

        if (loopFlag) {
            schema.properties.loop = {
                title: 'Loop Count',
                type: 'string',
                minimum: 1,
                default: 1,
                format: "grid",
                options: {
                    layout: 'grid',
                    grid_columns: 12
                }
            };

        }
        setEditorSchema(schema);
    }

    const generateFormSchemaData = (data) => {
        let schemaData = {};
        if (conditionFlag) {
            schemaData.condition =  data.condition != null && data.condition === false ? "false" : "true";
        }
        if (loopFlag) {
            schemaData.loop =  data.loop != null ? data.loop.toString() : "1";
        }
        setSchemaValues(schemaData);
    }


    useEffect(() => {
        fetchSimulationTransaction();
    }, [simulationTransactionId])

    const validation = (schema, value, path) => {
        var errors = [];
        if (path === "child_simulation_transaction_config.loop") {
            if (value === "" || value === null || value === undefined) {
                errors.push({
                    path,
                    property: 'format',
                    message: "Loop count is required"
                });
            } else if (!/^\d+$/.test(value) || parseInt(value, 10) <= 0) {
                errors.push({
                    path,
                    property: 'format',
                    message: "Loop count must be a positive integer greater than 0"
                });
            }
        }
        return errors;
    };

    let options = {
        form_name_root: "child_simulation_transaction_config",
        show_errors: "interaction",
        disable_collapse: true,
        disable_edit_json: true,
        disable_properties: true,
        remove_button_labels: true,
        input_width: '100px',
        disable_array_delete_all_rows: true,
        disable_array_delete_last_row: true,
        disable_array_add: true // For hiding + button
    }



    const onChangeJsonEditor = (data, jsonEditor) => {
        setEditorObj(jsonEditor);
        setFormData(data);
    }

    const onUpdate = () => {
        const editorValidationErrors = editorObj.validate();
        if ([...editorValidationErrors].length > 0) {
            return;
        }
        let dataToUpdate = {};
        if (formData.condition != null) {
            dataToUpdate.condition = formData.condition === "true" ? true : false;
        }
        if (formData.loop != null) {
            dataToUpdate.loop = parseInt(formData.loop);
        }
        
        dispatch(invokePostService('updateSimulationChildConfiguration', { dataToUpdate, simulationTransactionId, testsuiteId: entityId }, [testCaseId]))
            .then(response => {
                setIsFetching(false);
                if (response.status) {
                    dispatch(handleSnackBar({ open: true, message: `Testcase${testcase_name ? ` ${testcase_name}` : ""} updated`, severity: 'success' }));
                    dispatch(setReRender());
                    onClose();
                } else {
                    dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }))
                }
                setIsUpdating(false)
            });
    }

    return (
        <div>
            {isFetching ?
                <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '28vh' }} />
                :
                <JsonTableEditor options={options} schema={editorSchema} schemaValues={schemaValues} validation={validation} onChangeJsonEditor={onChangeJsonEditor} editorId="child_config_form" />
            }
            <Grid xs={12} style={{ justifyContent: 'flex-end', display: 'flex' }}>
                <UpdateCancel onUpdate={onUpdate} onCancel={onClose} updateDisable={isFetching || isUpdating} content={isUpdating ? "Updating.." : "Update"}/>
            </Grid>
        </div>
    )
}